module.exports = __webpack_public_path__ + "img/jingzhuangshu2.2bc23455.jpg";